function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896",
  transform: "scale(1.5)"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(25 0 0 25 75 175)",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  x: "5.75",
  y: "4.5",
  width: "22.5",
  height: "15.75",
  rx: "2.25"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F1F1F1",
  d: "M-1.39 2.72l2.451-3.773 33.967 22.057-2.451 3.774z"
}))));